<template>
    <div class="ly-note--editor">
        <textarea 
            class="ly-note--textarea" 
            @mouseup="mouseup"
            @keydown="keyFn"
            @input="inputFn"
            @blur="blurFn"
            v-model="textareaText"
            ref="textarea">
        </textarea>
    </div>
</template>
<script>
    /**
     * 文本编辑器
     */
    export default {
        props: {
            value: {
                type: Array,
                default: []
            }, // 分隔后得字符串列表
            isMirror: {
                type: Boolean,
                default: true
            } // 标识是否开启镜像操作
        },
        data () {
            return {
                textHistory: [], // 记录历史的文本，用于ctrl+z
                textSplitArr: [], // 对文字拆分出来的数组暂存
                textareaText: '', // 实际的操作文本
                textareaDom: null, // 文本域节点
                rowIndex: 0, // 当前鼠标所在的行索引
                colIndex: 0, // 鼠标所在列的索引，即间隔了多少字符
                selectionStart: 0, // 鼠标选取的初始位置
                selectionEnd: 0, // 鼠标选取的结束位置
            }
        },
        watch: {
            value () {
                this.setTextareaHeight()
            }
        },
        mounted () {
            // 获得输入操作节点
            this.textareaDom = document.querySelector('.ly-note--textarea')
            // 组合字符串
            this.textareaText = this.value.join('\n')
            // 记录文本历史
            this.textHistory.push(this.textareaText)
            this.textSplitArr = this.value
            this.setTextareaHeight()
        },
        methods: {
            /**
             * 设置textarea的高度
             */
            setTextareaHeight () {
                if (this.heightTimer) clearTimeout(this.heightTimer)
                this.heightTimer = setTimeout(() => {
                    this.$refs.textarea.style.height = this.value.length * 50 + 'px'
                }, 50)
            },
            keyFn (evt) {
                let evtName = ''  // 事件的名称
                if (evt.code === 'KeyZ') { // 撤销事件
                    evtName = 'NOTE_KEYZ'
                    this.back2history()
                } else {
                    switch (evt.keyCode) {
                        case 38: // 上键
                        case 40: // 下键
                        case 37: // 左键
                        case 39: // 右键
                            evtName = 'NOTE_KEYDOWN' 
                            break;
                        case 8: // 删除键
                            evtName = 'NOTE_DELETE'
                            break
                        case 13: // 回车键
                            evtName = 'NOTE_ENTER'
                            break
                        case 32: // 空格
                            evtName = 'NOTE_SPACE'
                            break
                        default:
                            evtName = ''
                            if (this.isMirror) evt.preventDefault()
                            break
                    }
                }
                if (evtName.length > 0) { 
                    if (this.timer) clearTimeout(this.timer)
                    this.timer = setTimeout(() => { // 这里要延时执行，等待光标位置渲染完
                        // 当前文本重新分隔
                        this.textSplitArr = this.textareaText.split('\n')
                        this.$emit('input', this.textSplitArr) 
                        if (this.isMirror) {
                            // 定位鼠标位置
                            this.mouseup(evt)
                            // 非方向键和撤销记录当前文本历史
                            if (evtName !== 'NOTE_KEYZ' && evtName !== 'NOTE_KEYDOWN') {
                                this.textHistory.push(this.textareaText)
                            }
                        }
                    }, 50)
                    if (this.isMirror) {
                        // 调用eventHub $emit方法发送事件
                        this.$eventHub.$emit(evtName)
                    }
                }
            },
            /**
             * 撤回到历史记录
             */
            back2history () {
                if (this.textHistory.length > 0) {
                    let last = this.textHistory.length - 1 // 最后一个元素的索引
                    this.textareaText = this.textHistory[last]
                    // 删除最后一个元素
                    this.textHistory.splice(last, 1)
                }
            },
             /**
             * 鼠标按下并松开之后的事件
             */
            mouseup (evt) {
                // 选中文本的起始索引
                this.selectionStart = this.textareaDom.selectionStart
                // 选中文本的结束索引
                this.selectionEnd = this.textareaDom.selectionEnd
                 if (this.isMirror) {
                    // 计算文本坐标位置
                    this.setRowIndex(this.selectionStart)
                }
            },
            /**
             * 内容输入的监听
             */
            inputFn (evt) {
                evt.preventDefault()
            },
            /**
             * 失去焦点的监听
             */
            blurFn () {
                this.$eventHub.$emit('NOTE_MOUSE_BLUR')
            },
            /**
             * 计算并设置行的索引
             */
            setRowIndex (start) {
                let strLen = 0 // 暂存当前进行到的文字的长度
                for (let i = 0, len = this.textSplitArr.length; i < len; i++) {
                    // 计算列的位置
                    this.colIndex = start - strLen
                    strLen += this.textSplitArr[i].length
                    if (i > 0) {
                        strLen++
                        this.colIndex--
                    }
                    if (start <= strLen) {
                        this.rowIndex = i
                        break
                    }
                }
                // 发送文本定位的事件
                this.$eventHub.$emit('NOTE_POINT',{
                    start: this.selectionStart,
                    end: this.selectionEnd,
                    row: this.rowIndex,
                    col: this.colIndex
                })
            }
        }
    }
</script>
<style>
    .ly-note--editor .ly-note--textarea {
        width: 1000px;
    }
</style>
